import React from "react";
import SidebarBase from "./SidebarBase";
export default function Sidebar() {
  return (
    <SidebarBase
      storageKeyMenus="catalogos_menus"
      storageKeySubmenu="submenu"
      storageKeyLoc="submenu_loc"
      storageKeyName="submenu_name"
    />
  );
}
